import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import type { DSSPaymentFrequency } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { paymentFrequencyMap } from '../../../utils/currencyUtil';
import ShoppingBasketExpanded from './expanded_shoppingbasket_components/ShoppingBasketExpanded';
import ShoppingBasketCoverable from './ShoppingBasketCoverable';

const ShoppingBasketCoverableList = ({
    coverables,
    paymentFrequencyPostfix,
    paymentFrequency,
    shouldDisplayCoverablesAsCancelled
}: {
    coverables: CoverableDTO[];
    paymentFrequencyPostfix: string;
    paymentFrequency: DSSPaymentFrequency;
    shouldDisplayCoverablesAsCancelled?: boolean;
}): React.JSX.Element => {
    return (
        <div>
            {coverables.map((coverable) => {
                return (
                    <ShoppingBasketCoverable
                        key={(coverable.lobCode ?? '') + (coverable.fixedId ?? '')}
                        coverable={coverable}
                        price={
                            paymentFrequency === paymentFrequencyMap.monthly
                                ? coverable.monthlyPrice?.amount ?? 0
                                : coverable.yearlyPrice?.amount ?? 0
                        }
                        paymentFrequencyPostfix={paymentFrequencyPostfix}
                        shouldDisplayCoverableAsCancelled={shouldDisplayCoverablesAsCancelled}
                    >
                        {shouldDisplayCoverablesAsCancelled ? undefined : (
                            <ShoppingBasketExpanded coverable={coverable} />
                        )}
                    </ShoppingBasketCoverable>
                );
            })}
        </div>
    );
};

export default ShoppingBasketCoverableList;
